// create a self-executing anonymous function to avoid leaking variables into the top level scope of window
(function() {
  // Executed after Swym Storefront JS Client has loaded all necessary resources.  
  function onSwymLoadCallback(swat) {  
    // Please make all Swym-related API calls inside this function.  
    // You can use the swat argument within this scope.  
        // Define eventname
        let event = 'sw:addedtocart';

        let lids = [];

        // Define success callback
        let onSuccess = function(lists) {
        // Successfully fetched all lists 
           console.log("Fetched all Lists", lists);
           // Loop through the array and push `lid` to lids
            lists.forEach(item => {
                if (item.lid) { // check if `lid` exists
                 lids.push(item.lid);
                }
            });
        }

        // Define error callback
        let onError = function(error) {
        // Error is an xhrObject
        console.log("Error while fetching all Lists", error);
        }

        // Call `fetchLists` function
        swat.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        });

        // Define success callback
        let onSuccess2 = function (response){
        // successfully removed list item from the all of the lists
          //console.log("Successfully removed a Product from many Lists", response);
        }

        // Define error callback
        let onError2 = function (error){
        // Error is an xhrObj
        console.log("Error while adding a Product to many Lists", error);
        }

        // Define the event listener function
        let listener = function(e) { 
           var data = e.detail.d.productData;	
           //console.log("YAY! Added the product to cart", e.detail.d.productData);
           // Build the product object
           // Target ID to match
            const targetId = data.id;

            // Find the element with matching data-epi
            const element = document.querySelector(`[data-epi="${targetId}"]`);

            if (element) {
            // Get the other attribute, e.g., data-du
            const dataDu = element.getAttribute('data-du');
            const dataempi = element.getAttribute('data-empi');
            var product = {
                    epi: data.id,                // variant ID (unique for each variant)
                    empi: dataempi, // product ID
                    du: dataDu  // product image URL
                };
                // update button state here...
                swat.removeProductFromLists(product, lids, onSuccess2, onError2);
            }
            
        };

        // Add listener for the 'addedtocart' event to the Swym Event Layer
        swat.evtLayer.addEventListener(event, listener);
  }  
  if (!window.SwymCallbacks) {  
    window.SwymCallbacks = [];  
  }  
  window.SwymCallbacks.push(onSwymLoadCallback);
})();